import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.536a4 4 0 0 1 6 3.467v7.994a4 4 0 1 1-8 0V19C6 9.611 13.611 2 23 2h2c9.389 0 17 7.611 17 17v12.997a4.007 4.007 0 0 1-3.043 3.887A8.998 8.998 0 0 1 30.003 44H27.83a3.002 3.002 0 0 1-2.827 2h-2.004A2.994 2.994 0 0 1 20 43c0-1.656 1.345-3 2.998-3h2.004c1.308 0 2.418.833 2.828 2h2.173a6.998 6.998 0 0 0 6.945-6.14A4.003 4.003 0 0 1 34 31.997v-7.994a4.004 4.004 0 0 1 6-3.468V19c0-8.284-6.716-15-15-15h-2C14.716 4 8 10.716 8 19v1.536Z",
    fill: "currentColor"
  }));
};

var SvgHeadset = styled(SvgComponent).withConfig({
  displayName: "Headset__SvgHeadset",
  componentId: "sc-bstsge-0"
})(["", " ", ""], size, color);
export default SvgHeadset;